import {
  GetConversionHistoriesParams,
  GetConversionHistoriesResponse,
  GetFillHistoriesParams,
  GetFillHistoriesResponse,
  GetFundingHistoriesResponse,
  GetOrderHistoriesParams,
  GetOrderHistoriesResponse,
  GetPnlHistoriesParams,
  GetPnlHistoriesResponse,
  GetProfitBoostHistoriesResponse,
  GetValidateAddressParams,
  GetValidateAddressResponse,
  GetWalletHistoriesParams,
  GetWalletHistoriesResponse,
  HistoryBaseParams,
} from './types';
import { apiClient } from '../../axios';

export const getPnlHistoriesApi = (params: GetPnlHistoriesParams) =>
  apiClient.get<GetPnlHistoriesResponse>('/v1/pnl', { params });

export const getFundingHistoriesApi = (params: HistoryBaseParams) =>
  apiClient.get<GetFundingHistoriesResponse>('/v1/funding/history', { params });

export const getFillHistoriesApi = (params: GetFillHistoriesParams) =>
  apiClient.get<GetFillHistoriesResponse>('/v1/execution/history', { params });

export const getOrderHistoriesApi = (params: GetOrderHistoriesParams) =>
  apiClient.get<GetOrderHistoriesResponse>('/v1/order/history', { params });

export const getWalletHistoriesApi = (params: GetWalletHistoriesParams) =>
  apiClient.get<GetWalletHistoriesResponse>('/v1/wallet/history', { params });

export const getConversionHistoriesApi = (params: GetConversionHistoriesParams) =>
  apiClient.get<GetConversionHistoriesResponse>('/v1/conversion/history', { params });

export const getValidateAddressApi = (params: GetValidateAddressParams) =>
  apiClient.get<GetValidateAddressResponse>('/v1/wallet/address/validate', { params });

export const getProfitBoostHistoriesApi = (params: HistoryBaseParams) =>
  apiClient.get<GetProfitBoostHistoriesResponse>('/v1/profit-boost/history', { params });
